import React from 'react';
import { CommandBarButton } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export const InputClearButton = _ref => {
  let {
    simple,
    onClick
  } = _ref;
  const clearIcon = {
    iconName: 'BoxMultiplySolid'
  };
  const label = !simple ? 'Clear' : undefined;
  return /*#__PURE__*/_jsx(CommandBarButton, {
    styles: {
      root: {
        padding: '0px',
        margin: '0px',
        width: 'auto',
        minWidth: 'auto'
      },
      flexContainer: {
        flexDirection: 'row-reverse'
      }
    },
    alt: label,
    title: label,
    text: label,
    iconProps: clearIcon,
    onClick: onClick
  });
};